module.exports = __webpack_public_path__ + "img/img-services.7f838139.png";